var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUngroupItemsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.222656 0.222168H5.55599V1.5555H14.8893V0.222168H20.2227V5.5555H18.8893V9.5555H21.556V8.22217H26.8893V13.5555H25.556V21.5555H26.8893V26.8888H21.556V25.5555H13.556V26.8888H8.22266V21.5555H9.55599V18.8888H5.55599V20.2222H0.222656V14.8888H1.55599V5.5555H0.222656V0.222168ZM21.556 13.5555V12.2222H18.8893V14.8888H20.2227V20.2222H14.8893V18.8888H12.2227V21.5555H13.556V22.8888H21.556V21.5555H22.8893V13.5555H21.556ZM14.8893 5.5555V4.22217H5.55599V5.5555H4.22266V14.8888H5.55599V16.2222H9.55599V13.5555H8.22266V8.22217H13.556V9.5555H16.2227V5.5555H14.8893ZM13.556 13.5555H12.2227V16.2222H14.8893V14.8888H16.2227V12.2222H13.556V13.5555Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroupItemsIcon);
export default __webpack_public_path__ + "static/media/ungroup-items-icon.cd1e3fce0e162b7b16e29129d14ef41d.svg";
export { ForwardRef as ReactComponent };